<script lang="ts" setup>
import { useAppShake } from '~/composables/useAppShake';
import { useGlobalMerchant } from '~/composables/useGlobalMerchant';
import { useGlobalMerchantError } from '~/composables/useGlobalMerchantError';
import { useIsDemo } from '~/composables/useIsDemo';

const merchant = useGlobalMerchant();
const merchantError = useGlobalMerchantError();
const { isShaking, stop: stopShaking } = useAppShake();
const isDemo = useIsDemo();
</script>

<template>
	<div class="lg:flex pt-16 lg:pt-0">
		<div
			v-if="isDemo"
			class="h-1 w-full fixed z-9998"
			style="background: repeating-linear-gradient(-55deg, #ad9c1d, #ad9c1d 10px, #ebd534 10px, #ebd534 20px)"
		/>
		<ProgrammeApplicationDefaultRejectedPrompt />
		<MerchantSidebar
			v-if="merchant && !merchantError"
			:merchant="merchant"
		/>
		<svg
			class="fixed bottom-0 left-0 z-[-1] hidden lg:block"
			width="404"
			height="404"
			fill="none"
			viewBox="0 0 404 404"
		>
			<defs>
				<pattern
					id="e229dbec-10e9-49ee-8ec3-0286ca089edf"
					x="0"
					y="0"
					width="20"
					height="20"
					patternUnits="userSpaceOnUse"
				>
					<rect
						x="0"
						y="0"
						width="4"
						height="4"
						class="text-neutral-200 dark:text-neutral-800"
						fill="currentColor"
					/>
				</pattern>
			</defs>
			<rect
				width="404"
				height="784"
				fill="url(#e229dbec-10e9-49ee-8ec3-0286ca089edf)"
			/>
		</svg>
		<div class="w-full px-4 sm:px-6 xl:pl-8 lg:pr-10 xl:pr-16 py-8 flex flex-col lg:min-h-screen">
			<div
				class="h-full"
				:class="{'animate-shake': isShaking }"
				@animationend="stopShaking"
			>
				<slot />
			</div>
			<MerchantFooter
				v-if="merchant"
				:merchant="merchant"
			/>
		</div>
	</div>
</template>
